/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmModelsActivateRegistryEntry } from "../../funcs/llmModelsActivateRegistryEntry.js";
import * as components from "../../models/components/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: components.ActivateRegistryEntryRequest$inboundSchema,
};

export const tool$llmModelsActivateRegistryEntry: ToolDefinition<typeof args> =
  {
    name: "llm-models-activate-registry-entry",
    description: `Activate a catalog entry

Claims a model name from one catalog source. Re-activation from the same source is idempotent; a different holder returns 409.`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] = await llmModelsActivateRegistryEntry(
        client,
        args.request,
        { fetchOptions: { signal: ctx.signal } },
      ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
